import "./App.css";

import NavTest from "./components/NavTest";
import Footer from "./components/Footer";
import { Route, Routes } from "react-router-dom";
import Store from "./pages/Store/Store/Store";
import Checkout from "./pages/Store/Checkout/Checkout";
import Product from "./pages/Store/Product/Product";
import Account from "./pages/Account/Account/Account";
import License from "./pages/Account/Licenses/License";
import Settings from "./pages/Account/Settings/Settings";
import Blog from "./pages/Blog/Blog/Blog";
import SinglePost from "./pages/Blog/SinglePost/SinglePost";
import HelpCenter from "./pages/HelpCenter/HelpCenter/HelpCenter";
import Documentations from "./pages/HelpCenter/Documentations/Documentations";
import SingleDocumentation from "./pages/HelpCenter/SingleDocumentation/SingleDocumentation";
import KnowledgeBase from "./pages/HelpCenter/KnowledgeBase/KnowledgeBase/KnowledgeBase";
import SingleArticleCategory from "./pages/HelpCenter/KnowledgeBase/SingleArticleCategory/SingleArticleCategory";
import SingleArticle from "./pages/HelpCenter/KnowledgeBase/SingleArticle/SingleArticle";
import Forums from "./pages/HelpCenter/KnowledgeBase/Forums/Forums/Forums";
import Topics from "./pages/HelpCenter/KnowledgeBase/Forums/Topics/Topics";
import SingleTopic from "./pages/HelpCenter/KnowledgeBase/Forums/SingleTopic/SingleTopic";
import TicketSystem from "./pages/HelpCenter/TicketSystem/TicketSystem/TicketSystem";
import SubmitTicket from "./pages/HelpCenter/TicketSystem/SubmitTicket/SubmitTicket";
import SubmitTicket2 from "./pages/HelpCenter/TicketSystem/SubmitTicket2/SubmitTicket2";
import SingleTicket from "./pages/HelpCenter/TicketSystem/SingleTicket/SingleTicket";
import Index from "./pages/Index";
import Login from "./pages/Login/Login";
import ResetPassword from "./pages/Login/ResetPassword";
import Register from "./pages/Login/Register";

function App() {
  return (
    <div>
      <NavTest />
      <Routes>
        <Route path="/" element={<Index />}></Route>
        <Route path="/index" element={<Index />}></Route>
        <Route path="/store" element={<Store />}></Route>
        <Route path="/checkout" element={<Checkout />}></Route>
        <Route path="/product" element={<Product />}></Route>
        <Route path="/account" element={<Account />}></Route>
        <Route path="/account-licenses" element={<License />}></Route>
        <Route path="/account-settings" element={<Settings />}></Route>
        <Route path="/blog" element={<Blog />}></Route>
        <Route path="/single-post" element={<SinglePost />}></Route>
        <Route path="/help-center" element={<HelpCenter />}></Route>
        <Route path="/documentations" element={<Documentations />}></Route>
        <Route
          path="/single-documentation"
          element={<SingleDocumentation />}
        ></Route>
        <Route path="/articles" element={<KnowledgeBase />}></Route>
        <Route
          path="/single-article-category"
          element={<SingleArticleCategory />}
        ></Route>
        <Route path="/single-article" element={<SingleArticle />}></Route>
        <Route path="/forums" element={<Forums />}></Route>
        <Route path="/topics" element={<Topics />}></Route>
        <Route path="/single-topic" element={<SingleTopic />}></Route>
        <Route path="/ticket" element={<TicketSystem />}></Route>
        <Route path="/ticket-submit" element={<SubmitTicket />}></Route>
        <Route path="/ticket-submit-2" element={<SubmitTicket2 />}></Route>
        <Route path="/single-ticket" element={<SingleTicket />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/reset-password" element={<ResetPassword />}></Route>
        <Route path="/register" element={<Register />}></Route>
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
